// extracted by mini-css-extract-plugin
export default {"menu-item":"MenuItem_menu-item__nVuio","icon-right":"MenuItem_icon-right__Q27EY"};